<div class="page">

    <div class="header">

        <button class="back-btn" (click)="goBack()">

            <i class="fa-solid fa-arrow-left"></i>

        </button>

        <img class="hospital-logo" [src]="hospital.image" alt="Hospital">

        <div>

            <h2>{{hospital.name}}</h2>

            <p>Hospital Details</p>

        </div>

    </div>

    <!-- Information -->

    <div class="card">

        <h3>Hospital Information</h3>

        <div class="info">

            <i class="fa-solid fa-user-doctor"></i>

            <span>{{hospital.doctor}}</span>

        </div>

        <div class="info">

            <i class="fa-solid fa-location-dot"></i>

            <span>{{hospital.address}}</span>

        </div>

        <div class="info">

            <i class="fa-solid fa-phone"></i>

            <span>{{hospital.phone}}</span>

        </div>

    </div>

    <!-- Notes -->

    <div class="card">

        <h3>Notes</h3>

        <p class="notes">

            {{hospital.notes}}

        </p>

    </div>

    <!-- Services -->

    <div class="card">

        <div class="section-title">

            <h3>Available Services</h3>

            <span>{{hospital.services.length}}</span>

        </div>

        <div class="service-grid">

            <div class="service-card" *ngFor="let service of hospital.services">

                <div class="service-image">
                    <img [src]="service.image" [alt]="service.name">
                </div>

                <div class="service-content">

                    <h4>{{ service.name }}</h4>

                    <small>{{ service.description }}</small>

                </div>

            </div>

        </div>

    </div>

</div>